import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../lib/api';
import { Shield, CheckCircle2, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function DiagnosticsSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id') || '';
  const [state, setState] = useState('checking'); // checking | ok | error
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!sessionId) { setState('error'); return; }
    let tries = 0;
    const check = async () => {
      try {
        const { data } = await api.get(`/api/diagnostics/subscribe/status/${sessionId}`);
        if (data.status === 'paid' || data.status === 'complete' || data.subscription) {
          setInfo(data); setState('ok'); return;
        }
      } catch { /* retry */ }
      tries += 1;
      if (tries < 8) setTimeout(check, 1500);
      else setState('error');
    };
    check();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-6">
      <div className="max-w-md text-center">
        <Link to="/" className="inline-flex items-center gap-2 mb-8">
          <div className="w-8 h-8 bg-[#D4A843] rounded-lg flex items-center justify-center"><Shield className="w-4 h-4 text-[#0A0A0A]" /></div>
          <span className="text-white font-bold text-lg">TechOps</span>
        </Link>

        {state === 'checking' && (
          <>
            <Loader2 className="w-10 h-10 text-[#D4A843] animate-spin mx-auto mb-4" />
            <h1 className="text-xl font-bold text-white">Confirming your subscription…</h1>
          </>
        )}
        {state === 'ok' && (
          <>
            <div className="w-16 h-16 bg-[#D4A843] rounded-2xl mx-auto mb-5 flex items-center justify-center">
              <CheckCircle2 className="w-8 h-8 text-[#0A0A0A]" />
            </div>
            <h1 className="text-2xl font-bold text-white mb-2">You're covered ✨</h1>
            <p className="text-sm text-gray-400 mb-1">Device Care is now active for <span className="text-white">{info?.customer_email || 'your email'}</span>.</p>
            <p className="text-sm text-gray-400 mb-8">You'll get a health report every month and alerts whenever something needs attention.</p>
            <Link to="/diagnostics"><Button className="bg-[#D4A843] hover:bg-[#E8C972] text-[#0A0A0A] font-semibold rounded-lg">Run another scan</Button></Link>
          </>
        )}
        {state === 'error' && (
          <>
            <h1 className="text-xl font-bold text-white mb-2">Couldn't confirm your payment</h1>
            <p className="text-sm text-gray-400 mb-6">If you were charged, contact sales@eigooinc.net with session id <code className="text-[#D4A843]">{sessionId}</code>.</p>
            <Link to="/diagnostics"><Button variant="outline" className="border-gray-700 text-white rounded-lg">Back to diagnostics</Button></Link>
          </>
        )}
      </div>
    </div>
  );
}
